import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Paper, Typography } from '@mui/material'

import { Wallet } from 'types/wallet'

import s from './styles'

interface Props {
  wallet: Wallet
}

const OrganizationWalletCard: FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} sx={s.container}>
      <Box sx={s.flexBox}>
        <Typography sx={s.text}>{wallet.type}</Typography>
        <Typography sx={s.text}>
          {t('Pages.Organizations.Balance')}: {wallet.balance}
        </Typography>
      </Box>
      <Box sx={s.secondFlexBox}>
        <Typography sx={s.name}>{wallet.name}</Typography>
        <Typography sx={s.text}>
          {t('Pages.Organizations.Reserved')} {wallet.reserved}
        </Typography>
      </Box>
    </Paper>
  )
}

export default OrganizationWalletCard
